function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSicherFuerElektrischeKontakte = function SvgSicherFuerElektrischeKontakte(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.6 76.45"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M54.36 1.32c18.4 0 33.6 13.53 36.39 31.12h17.53v11.58H90.75C87.96 61.6 72.77 75.14 54.36 75.14s-33.6-13.53-36.39-31.12H1.32V32.44h16.66C20.76 14.85 35.96 1.32 54.36 1.32Zm-8.34 13.14h18.77l-8 18.21h11.39L47.56 64.06l6.2-24.08H41.71z",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.63px"
    }
  }));
};
export default SvgSicherFuerElektrischeKontakte;